import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgIf} from "@angular/common";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tl-confirm-modal',
  standalone: true,
  imports: [
    NgIf, TranslateModule
  ],
  templateUrl: './confirm-modal.component.html',
})
export class ConfirmModalComponent {
  @Input() modalIcon = '';
  @Input() modalTitle = '';
  @Input() modalDescription = '';
  @Input() confirmBtnText = 'Confirm';
  @Input() cancelBtnText = 'Cancel';
  @Output() cancelModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();

}
